<template>
  <ItemRow ref="root">
    <ItemWithLabel
      v-for="(column, index) in columns"
      :key="index"
      :class="[$style.item, `${$style.item}--${column.dataFieldName}`]"
      :column="column"
      :data-test-id="$testId(column.dataFieldName)"
    >
      <span
        v-if="column.dataFieldName === $options.manageAccountColumns.awsAccountIsActivated"
        :class="$style.activated"
      >
        <IconButton
          v-if="isPending && false"
          :class="$style.IconButton"
          :data-test-id="$testId('RefreshBtn')"
          hasNoBackground
          :icon="statusIcon"
          text="Refresh"
          type="secondary"
          @click="handleRefreshClick"
        />

        <Icon
          v-else
          :class="`${$style.statusIcon}--${itemData.statusType}`"
          :icon="statusIcon"
          inline
        />
      </span>

      <span
        v-else-if="column.dataFieldName === $options.manageAccountColumns.awsAccountAlias"
      >
        <span
          v-if="itemData[column.dataFieldName]"
          :class="$style.aliasContainer"
        >
          <span :class="$style.alias">
            {{ itemData[column.dataFieldName] }}
          </span>
          <ButtonEdit
            :data-test-id="$testId('EditAliasButton')"
            :scale="1.5"
            @click="toggleEditModal"
          />
        </span>
        <ButtonLink
          v-else
          :data-test-id="$testId('CreateAliasButton')"
          text="Add an alias"
          @click="toggleEditModal"
        />
      </span>

      <span v-else-if="column.dataFieldName === $options.manageAccountColumns.updatedAt">
        {{ getFormatedDateTime(itemData[column.dataFieldName]) }}
      </span>

      <span v-else-if="column.dataFieldName === $options.manageAccountColumns.createdAt">
        {{ getFormatedDateTime(itemData[column.dataFieldName]) }}
      </span>

      <span v-else-if="column.dataFieldName === $options.manageAccountColumns.objectId">
        <IconButton
          :class="$style.IconButton"
          :data-test-id="$testId('DeleteBtn')"
          hasNoBackground
          icon="delete"
          text="Delete"
          type="error"
          @click="toggleDeleteModal"
        />
      </span>

      <span
        v-else
        :class="$style.valueText"
        :data-test-id="$testId('Value')"
      > {{ itemData[column.dataFieldName] }} </span>
    </ItemWithLabel>
    <DeleteAccountModal
      :accountID="itemData.id"
      :awsAccountNumber="itemData.awsAccountId"
      :data-test-id="$testId('DeleteModal')"
      :showModal="showModal"
      @cancel="toggleDeleteModal"
      @delete="toggleDeleteModal"
    />
    <EditAccountModal
      :account="itemData"
      :data-test-id="$testId('EditModal')"
      :showModal="showEditModal"
      @cancel="toggleEditModal"
      @save="toggleEditModal"
    />
  </ItemRow>
</template>

<script>
import {
  ButtonEdit,
  ButtonLink,
  Icon,
  IconButton,
  ItemRow,
  ItemWithLabel,
} from '@jumpcloud/ui-components';
import { accountState, icons, manageAccountColumns } from 'client/CloudInsights/constants/ManageAccountConstants';
import DeleteAccountModal from 'client/CloudInsights/components/DeleteAccountModal.vue';
import EditAccountModal from 'client/CloudInsights/components/EditAccountModal.vue';
import moment from 'moment';

export default {
  name: 'ManageAccountItemRow',

  components: {
    ButtonEdit,
    ButtonLink,
    DeleteAccountModal,
    EditAccountModal,
    Icon,
    IconButton,
    ItemRow,
    ItemWithLabel,
  },

  props: {
    columns: {
      type: Array,
      default: () => [],
    },

    itemData: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      showEditModal: false,
      showModal: false,
    };
  },

  icons,
  manageAccountColumns,

  computed: {
    isPending() {
      return this.itemData.statusType === accountState.pending;
    },

    statusIcon() {
      return icons[this.itemData.statusType];
    },
  },

  methods: {
    getFormatedDateTime(dateTime) {
      return moment(new Date(dateTime)).format('MM/DD/YY @ h:mm:ss');
    },
    handleRefreshClick() {
      // Placeholder for future work
    },
    toggleDeleteModal() {
      this.showModal = !this.showModal;
    },
    toggleEditModal() {
      this.showEditModal = !this.showEditModal;
    },
  },
};
</script>

<style scoped module>
.alias {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 150px;
}

.aliasContainer {
  align-items: center;
  display: flex;
}

.IconButton {
  font-weight: 500 !important;
}

.item {
  align-items: center;
  display: flex;

  /* !important used to override ItemListWithLabel style: https://github.com/TheJumpCloud/jumpcloud-ui-components/blob/master/src/components/ItemList/ItemWithLabel.vue#L54 */
  overflow: visible !important;
  width: 100%;
}

.statusIcon {
  color: var(--jcBlack);
}

.statusIcon--error {
  color: var(--jcError);
}

.statusIcon--validated {
  color: var(--jcSuccess);
}

.valueText {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
